import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Header from './Header';
import Footer from './Footer';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Header />
    <div style={{margin: 'auto', width: '50%'}}>
      <p style={{color: 'white'}}>***NOTICE***</p>
      <p style={{color: 'white'}}>In order to get the starting image of the slideshow that you are wanting, choose the image type first below the slideshow then choose the image from the calendar.</p>
      <p style={{color: 'white'}}>If an image does not appear when you choose one from the calendar then the image you chose was not of the type for the slideshow you chose.</p>
    </div>
    <App />
    <Footer />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
